<div class="mat-dialog-content">
  <div mat-dialog-title>
    <div class="head-select-room-modal-list">
      <h2>Selecionar sala</h2>
      <mat-icon (click)="close()" class="close-modal">close</mat-icon>
    </div>
  </div>
  <div mat-dialog-content>
    <div class="body-select-room-modal-list">
      <span class="description">Selecione a sala que deseja chamar os pacientes:</span>
      <div class="filters">
        <div class="row">
          <mat-form-field appearance="outline">
            <mat-icon matPrefix class="my-icon">search</mat-icon>
            <mat-label>Pesquisar</mat-label>
            <input matInput type="text" id="searchText" name="searchText" [(ngModel)]="searchText" (keyup)="onKeySearch()">
          </mat-form-field>
        </div>
      </div>
      @if (isLoading) {
        <app-loading-list></app-loading-list>
      }
      <div class="body-select-room-modal-list__options">
        @for (item of filteredListRoomStruct; track item) {
          <div mat-flat-button color="accent" class=" body-select-room-modal-list__options--buttons" (click)="selectItem(item)">
            <span class="option-name truncate">{{item.sectorName}} - {{item.roomName}} </span>
            <mat-icon class="option-icon">navigate_next</mat-icon>
          </div>
        }
      </div>
    </div>
  </div>
</div>